import { cn } from '../../../lib/styles';
import { Heading } from '../heading/heading.spark';
import { Text } from '../text/text.spark';
import { EmptyStateIllustration } from './illustrations';
import type { EmptyStateProps } from './types';

export function EmptyState(props: EmptyStateProps) {
  return (
    <div
      className={cn(
        'mx-auto flex max-w-md flex-col items-center gap-4',
        props.compact ? 'py-6' : 'py-12',
      )}
    >
      {props.imageType && (
        <EmptyStateIllustration imageType={props.imageType} className="size-48" />
      )}
      <div className="flex w-full flex-col items-center gap-1">
        <Heading level="h2" style="md">
          {props.title}
        </Heading>
        {props.subtitle && (
          <span className="text-center">
            <Text variant="secondary">{props.subtitle}</Text>
          </span>
        )}
        <div className="mt-1 flex w-full flex-col items-center">{props.children}</div>
      </div>
    </div>
  );
}
